import { Controller } from "@hotwired/stimulus"
import IMask from 'imask'

export default class extends Controller {
  static targets = ['input']

  connect () {
    if (!this.inputTarget.getAttribute('data-mask')) {
      throw 'Atributo data-mask necessário'
    }

    let dataMask = this.inputTarget.getAttribute('data-mask')

    if (dataMask == 'phone') {
      dataMask = [
        {
          mask: '(00) 00000-0000'
        },
        {
          mask: '(00) 0000-0000'
        }
      ]
    }

    IMask(
      this.inputTarget, {
        mask: dataMask
      })
  }
}
